import {EGoogleTagManagerEventType} from './IGoogleTagManager';
import {EEventSource, IEventData} from 'coreClasses/events/IEvents';

import EventModel from './eventModels/EventModel';

import GeneralFactory from 'coreClasses/GeneralFactory';
import AccountCreationEventModel from './eventModels/common/AccountCreationEventModel';
import NewsletterSubscriptionEventModel from './eventModels/common/NewsletterSubscriptionEventModel';
import PageViewEventModel from './eventModels/common/PageViewEventModel';
import ProductAddToWishlistEventModel from './eventModels/common/ProductAddToWishlistEventModel';
import ProductDetailsPageViewEventModel from './eventModels/common/ProductDetailsPageViewEventModel';
import ProductListPageViewEventModel from './eventModels/common/ProductListPageViewEventModel';
import RecommendationsReadyEventModel from './eventModels/common/RecommendationsReadyEventModel';
import ECommerceProductAddToCartEventModel from './eventModels/ecommerce/EcommerceProductAddToCartEventModel';
import ECommerceProductClickEventModel from './eventModels/ecommerce/EcommerceProductClickEventModel';
import ECommerceProductDetailViewEventModel from './eventModels/ecommerce/EcommerceProductDetailViewEventModel';
import ECommerceProductListLoadEventModel from './eventModels/ecommerce/EcommerceProductListLoadEventModel';
import ECommerceProductRemoveFromCartEventModel from './eventModels/ecommerce/EcommerceProductRemoveFromCartEventModel';
import PromotionClickEventModel from './eventModels/ecommerce/PromotionClickEventModel';
import PromotionViewEventModel from './eventModels/ecommerce/PromotionViewEventModel';
import SearchQueryEventModel from './eventModels/common/SearchQueryEventModel';
import UserInfoEventModel from './eventModels/common/UserInfoEventModel';
import SplashPageViewEventModel from './eventModels/common/SplashPageViewEventModel';
import ViewSizesEventModel from './eventModels/ecommerce/ViewSizesEventModel';
import CartUpdatedEventModel from './eventModels/common/CartUpdatedEventModel';
import WishlistUpdatedEventModel from './eventModels/common/WishlistUpdatedEventModel';
import ClickImageCtaEventModel from './eventModels/common/ClickImageCtaEventModel';

/**
 * Represents EventModelFactory
 */
class EventModelFactory extends GeneralFactory {
	/**
	 * Creates event model
	 * @param {EGoogleTagManagerEventType} eventType - event type
	 * @param {IEventData} eventData - event data
	 * @returns {EventModel} - event model
	 */
	create(eventType: EGoogleTagManagerEventType, eventData: IEventData): EventModel {
		let eventModel: EventModel = null;

		switch (eventType) {
			case EGoogleTagManagerEventType.PAGE_VIEW:
			case EGoogleTagManagerEventType.CHANGE_LOCAL:
				switch (eventData.pageType as EEventSource) {
					case EEventSource.PDP:
						eventModel = new ProductDetailsPageViewEventModel(this.managerRepository, eventData);

						break;
					case EEventSource.PLP:
						eventModel = new ProductListPageViewEventModel(this.managerRepository, eventData);

						break;
					default:
						eventModel = new PageViewEventModel(this.managerRepository, eventData);

						break;
				}

				break;

			case EGoogleTagManagerEventType.SPLASH_PAGE_VIEW:
				eventModel = new SplashPageViewEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.LOGS_IN:
			case EGoogleTagManagerEventType.LOGS_OUT:
			case EGoogleTagManagerEventType.CUSTOMER_CHANGED:
				eventModel = new UserInfoEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.NEWSLETTER_SUBSCRIPTION:
				eventModel = new NewsletterSubscriptionEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.CUSTOMER_REGISTRATION:
				eventModel = new AccountCreationEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.RECOMMENDATIONS_LOADED:
				eventModel = new RecommendationsReadyEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.PRODUCT_ADD_TO_WISHLIST:
				eventModel = new ProductAddToWishlistEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.PRODUCT_ADD_TO_CART:
				eventModel = new ECommerceProductAddToCartEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.PRODUCT_REMOVE_FROM_CART:
				eventModel = new ECommerceProductRemoveFromCartEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.PRODUCT_CLICK:
				eventModel = new ECommerceProductClickEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.PRODUCT_DETAIL_VIEW:
				eventModel = new ECommerceProductDetailViewEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.PRODUCT_LIST_LOAD:
				eventModel = new ECommerceProductListLoadEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.SEARCH_QUERY:
				eventModel = new SearchQueryEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.PROMOTION_CLICK:
				eventModel = new PromotionClickEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.PROMOTION_VIEW:
				eventModel = new PromotionViewEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.VIEW_SIZES:
				eventModel = new ViewSizesEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.CART_UPDATED:
				eventModel = new CartUpdatedEventModel(this.managerRepository, eventData);

				break;

			case EGoogleTagManagerEventType.WISHLIST_UPDATED:
				eventModel = new WishlistUpdatedEventModel(this.managerRepository, eventData);

				break;
			case EGoogleTagManagerEventType.CLICK_IMAGE_CTA:
				eventModel = new ClickImageCtaEventModel(this.managerRepository, eventData);

				break;
			default:
				break;
		}

		return eventModel;
	}
}

export default EventModelFactory;
